






import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'TrackInfoImage',
  props: { blok: { type: Object } }
});
